import React, { useContext, useMemo } from 'react';

import Lozenge from '@atlaskit/lozenge/new/lozenge';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { getCSSCustomProperty } from '@atlaskit/tokens/utils/get-css-custom-property';
import { getTokenId } from '@atlaskit/tokens/utils/get-token-id';

import type { TransformedTokenMerged } from '../types';
import { Label } from './label';
import TokenButton from './token-button';
import { TokenNameSyntaxContext } from './token-name-syntax-context';

enum LozengeAppearance {
	deprecated = 'warning',
	deleted = 'danger',
	experimental = 'discovery',
}

type TokenNameProps = Pick<TransformedTokenMerged, 'name' | 'attributes'>;

const TokenName = ({ name, attributes }: TokenNameProps): React.JSX.Element => {
	const { syntax } = useContext(TokenNameSyntaxContext);

	const formattedName = useMemo(() => {
		if (syntax === 'css-var') {
			return getCSSCustomProperty(name);
		}
		return getTokenId(name);
	}, [name, syntax]);

	return (
		<Inline space="space.100" alignBlock="center">
			<TokenButton copyValue={formattedName}>
				<Label appearance="subtle">{formattedName}</Label>
			</TokenButton>
			{attributes.state !== 'active' && (
				<Lozenge appearance={LozengeAppearance[attributes.state]}>{attributes.state}</Lozenge>
			)}
		</Inline>
	);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TokenName;
